import type { ValidationErrorResponse } from "./validationErrorResponse.server";

export const isValidationError = (data: unknown) => {
  return (
    !!data &&
    typeof data === "object" &&
    ("globalErrors" in data || "fieldErrors" in data)
  );
};

/**
 * COM-804 — a validation-error-shaped payload (so every settle observer still
 * takes its failure branch) flagged `upstreamTimeout: true`: the action's
 * upstream call timed out, so its outcome is UNKNOWN, not rejected. Sent with
 * HTTP 503 by the basket action (`upstreamTimeoutError`).
 */
export const isUpstreamTimeoutResponse = (data: unknown): boolean =>
  isValidationError(data) &&
  (data as { upstreamTimeout?: unknown }).upstreamTimeout === true;

// Pulls the first non-empty user-facing message out of a validationError
// payload: globalErrors take precedence over fieldErrors. Returns null when
// the payload isn't a validation error or both arrays are empty so callers
// can branch on "no actual message to show".
export const extractValidationMessage = (data: unknown): string | null => {
  if (!isValidationError(data)) return null;
  const d = data as {
    globalErrors?: string[];
    fieldErrors?: Record<string, string>;
  };
  const global = d.globalErrors?.find(Boolean);
  if (global) return global;
  const field = d.fieldErrors
    ? Object.values(d.fieldErrors).find(Boolean)
    : undefined;
  return field ?? null;
};

export const validationErrorToString = (error: ValidationErrorResponse) => {
  let str = "";
  //TODO
  // ((error.fieldErrors && Object.entries(error.repopulateFields)) || [])
  //   .map(([field, fieldError]) => {
  //     return `${field}: ${fieldError}`;
  //   })
  //   .join(", ");
  str = str.concat((error.globalErrors || []).join(", "));

  return `Error: ${str}`;
};
